import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import { API } from '../api';
import { IFetchPriceResponseReportingQuery, IPriceResponseMetric } from './interface';

export const fetchPriceResponseReportingData = async (
    { start, end, companyId, market, zone }: IFetchPriceResponseReportingQuery,
    signal?: AbortSignal | null
): Promise<IPriceResponseMetric> => {
    const path = `/price-response/reporting?${new URLSearchParams({
        companyId: companyId.toString(),
        start: start.toISOString(),
        end: end.toISOString(),
        market,
        loadZone: zone,
    })}`;

    const response = await API.fetch(path, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const respBody = await response.json();

    if (response.ok) {
        return respBody;
    }
    throw new Error(respBody?.error?.message || `Cannot load price response metrics data!`);
};

export const exportPriceResponse = async ({ start, end, companyId, market, zone }: IFetchPriceResponseReportingQuery) => {
    const path = `/price-response/reporting?${new URLSearchParams({
        ...(companyId && { companyId: companyId.toString() }),
        start: start.toISOString(),
        end: end.toISOString(),
        market,
        loadZone: zone,
        format: 'pdf',
    })}`;

    const response = await API.fetch(path, {
        headers: {
            'Content-Type': 'application/pdf',
        },
    });

    const respBody: any = await response.blob();
    if (response.ok) {
        const blob = new Blob([respBody], { type: 'application/pdf' });
        saveAs(blob, `PriceResponseReporting_${format(start, 'MM-dd-yyyy')}-${format(end, 'MM-dd-yyyy')}.pdf`);
    } else {
        const respBody: any = await response.json();
        throw new Error(respBody?.error?.message || `Cannot export data in pdf!`);
    }
};
